import * as Yup from "yup";

export const missingPatientDetailValidationSchema = Yup.object().shape({
  battery: Yup.string().required("Battery status is required."),
});
